module.exports = __webpack_public_path__ + "img/release.7889d1ca.png";